import { SxProps } from '@mui/material';

import {
  StyledBadgeStack,
  StyledStack,
} from '@webclient/components/upgrade-modal/components/with-featured-badge/styles';

import BadgeRoundedIcon from '~icons/knowz-iconify/badge-rounded';

import { Text } from '@knowz/knowz-ui';
import { useTranslate } from '@tolgee/react';

type Props = {
  sx?: SxProps;
};

export default function WithFeaturedBadge<T extends Props = Props>(
  FeaturedPlan: React.ComponentType<T>,
) {
  function PlanCardWithBadge(props: Omit<T, keyof Props>) {
    const { t } = useTranslate();
    return (
      <StyledStack>
        <StyledBadgeStack>
          <Text
            variant="textMd"
            weight="semibold"
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <BadgeRoundedIcon />
            &nbsp;{t('layout.upgrade.mostPopular', 'Most popular')}
          </Text>
        </StyledBadgeStack>
        <FeaturedPlan {...(props as T)} />
      </StyledStack>
    );
  }

  return PlanCardWithBadge;
}
